'use strict';

const debounce = require('lodash/debounce');

$(document).ready(function () {
    const $banner = document.querySelector('.js-promo-banner');

    if (!$banner) return;

    const $bannerContainer = $banner.closest('.experience-assets-promoBanner');
    const $close = document.querySelector('.js-promo-banner-close');
    const bannerSlidesContent = $($banner).find('.rich-text');

    /**
     * Updates the margin of the banner container based on the banner's sticky state.
     */
    const updateBannerMargin = () => {
        if ($banner.classList.contains('is-sticky')) {
            const bannerHeight = $banner.clientHeight;
            $bannerContainer.style.marginBottom = `${bannerHeight}px`;
        }
    };

    if (sessionStorage.getItem('promoBannerClosed') !== 'true') {
        $bannerContainer.classList.add('show-banner');
        $('body').trigger('promoBannerUpdated');
    }

    updateBannerMargin();

    $close.addEventListener('click', () => {
        $bannerContainer.classList.remove('show-banner');
        sessionStorage.setItem('promoBannerClosed', 'true');
        $('body').trigger('promoBannerClosed');
        $('body').trigger('promoBannerUpdated');
    });

    $('body').on('click', '#copyBannerPromotionalCode', function (e) {
        e.preventDefault();

        const button = $(this);
        const buttonText = button.find('span');
        const code = button.data('code');

        if (code && !button.hasClass('copied')) {
            navigator.clipboard.writeText(code).then(function () {
                buttonText.text(button.data('copied'));
                button.addClass('copied');

                setTimeout(function () {
                    buttonText.text(button.data('copy'));
                    button.removeClass('copied');
                }, 3000);
            }).catch(function () {
                // ignore error
            });
        }
    });

    /**
     * Gets banner slide content height
     * @param {HTMLElement} slide - Slide content element
     * @returns {number} Slide height
     */
    const getSlideHeight = (slide) => {
        const $slide = $(slide);

        if ($slide.length === 0) return 0;
        if ($slide.is(':visible')) return slide.scrollHeight;

        $slide.closest('.carousel-item ').css({ position: 'absolute', visibility: 'hidden', display: 'block' });
        const height = slide.scrollHeight;
        $slide.closest('.carousel-item ').css({ position: '', visibility: '', display: '' });
        return height;
    };

    /**
     * Updates the minimum height of the banner slides content.
     */
    const updateBannerMinHeight = () => {
        bannerSlidesContent.css('min-height', '');
        const maxHeight = Math.max(...bannerSlidesContent.toArray().map(getSlideHeight));
        bannerSlidesContent.css('min-height', `${maxHeight}px`);
    };

    updateBannerMinHeight();

    $(window).on('resize', debounce(() => {
        updateBannerMargin();
        updateBannerMinHeight();
    }, 250));
});
